import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject } from 'rxjs';

import { ScootaverseEntryRulesService } from 'app/modules/scootaverse/services/scootaverse-entry-rules.service';
import { Loggable } from 'app/utils/logging/loggable';
import Social from 'entity/Social';
import SocialEntryConfiguration from 'entity/SocialEntryConfiguration';

@Component({
  selector: 'entry-flow-apply-rooms',
  templateUrl: './entry-flow-apply-rooms.component.html',
  styleUrls: ['./entry-flow-apply-rooms.component.scss'],
  standalone: false,
})
export class EntryFlowApplyRoomsComponent extends Loggable implements OnDestroy, OnInit {
  private destroyed$ = new ReplaySubject<boolean>(1);

  @Input() public rooms?: Social[];
  @Input() public scootaverseId?: string;
  @Input() public settings?: SocialEntryConfiguration;
  @Input() public hasStartingPoint = false;
  @Output() public applySocials = new EventEmitter<string>();

  public selectedRoomArray?: string;
  public takenRooms?: string[] = [];
  public loading = false;

  public constructor(
    private scootaverseEntryRulesService: ScootaverseEntryRulesService,
    private toastrService: ToastrService,
  ) {
    super();
    this.setDisplayName('EntryFlowApplyRoomsComponent');
  }

  public ngOnInit(): void {
    this.info('init');
    this.loading = true;
    this.loadSelectedRooms();
    this.loadFlowRooms()
      .then(() => {
        this.loading = false;
      })
      .catch((err) => {
        this.info('Error loading taken rooms. Try again later: ', err);
        this.loading = false;
      });
  }

  public loadSelectedRooms(): void {
    if (this.settings?.associatedSocialIds) {
      this.selectedRoomArray = this.settings?.associatedSocialIds[0];
    }
  }

  public async loadFlowRooms(): Promise<void> {
    if (this.scootaverseId) {
      await this.scootaverseEntryRulesService
        .getEntryConfigurations(this.scootaverseId)
        .then((flows) => {
          flows.forEach((flow) => {
            if (flow.associatedSocialIds) {
              this.takenRooms?.push(...flow.associatedSocialIds);
            }
          });
        })
        .catch((err) => {
          this.info('Error loading taken rooms. Try again later: ', err);
          this.toastrService.error('Error loading taken rooms. Try again later');
        });
    }
  }

  public roomIsTaken(room: Social) {
    if (room.socialId) {
      return !!(
        this.takenRooms?.includes(room.socialId) && !this.settings?.associatedSocialIds?.includes(room.socialId)
      );
    }
  }

  public get isDisabled() {
    return !this.selectedRoomArray;
  }

  public nextStep() {
    this.applySocials.emit(this.selectedRoomArray);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
